import api, { fetchData } from './api';
import Paginacao from '../types/paginacao';
import { ShipInfo } from '../types/shipinfo';
import { ShippingData } from '../pages/ShipInfo/components/ShippingInfoModal';

export interface ShipInfoApiResponse {
  data: ShipInfo;
  messages: any; 
}

export const getShipInfoPaginated = async (
    paginacao: Paginacao,
    filters: any = {}
  ) => {
    try {
      const endpoint: string = '/Release/all/paginado';
      const params: Record<string, any> = {
        pageNum: paginacao.pageNum + 1,
        quantityPerPage: paginacao.quantityPerPage,
        ...filters
      };
  
      const response = await fetchData<ShipInfo>(endpoint, params);
  
      return response;
    } catch (error) {
      console.error('Erro ao buscar lista de ShipInfo:', error);
      throw error;
    }
};

export const getShipInfo = async (
    paginacao: Paginacao,
    filters: any = {}
  ) => {
  try {
    const endpoint: string = '/Release/list';

    // O backend só honra pageNum/quantityPerPage/order/sort quando "paginated=true"
    // é enviado (ver PaginacaoDeResultadoReleaseStrategy). Sem isso, a grid de ShipInfo
    // não reflete nem a mudança de "rows per page" nem a ordenação por coluna.
    const params: Record<string, any> = {
      ...filters,
      paginated: true,
      "paginacao.pageNum": (paginacao?.pageNum ?? 0) + 1,
      "paginacao.quantityPerPage": paginacao?.quantityPerPage ?? 20,
      "paginacao.order": paginacao?.order,
      "paginacao.sort": paginacao?.sort,
    };

    // Remove parâmetros vazios/indefinidos para não sobrescrever os defaults do backend.
    for (const key of Object.keys(params)) {
      const value = params[key];
      if (value === undefined || value === null || value === "") {
        delete params[key];
      }
    }

    const response = await fetchData<ShipInfo>(endpoint, params);
    return response;
  } catch (error) {
    console.error(`Erro ao buscar ShipInfo`, error);
    throw error;
  }
};
  
export const getShipInfoById = async (id: number) => {
  try {
    const response = await api.get(`/CargoInfo/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao buscar ShipInfo com ID ${id}`, error);
    throw error;
  }
};

export const getShipInfoShipped = async (id: number, data: ShippingData) => {
  try {
    const response = await api.put(`/Release/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Erro ao adicionar shipped com ID ${id}`, error);
    throw error;
  }
};

export const cancelShippingRequest = async (id: number) => {
  try {
    const response = await api.put(`/Release/cancelar-shipping/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao cancelar shipped com ID ${id}`, error);
    throw error;
  }
};